const Support = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 7.9375C11.3272 7.9375 10.75 8.49845 10.75 9.22999C10.75 9.78228 10.3023 10.23 9.75 10.23C9.19772 10.23 8.75 9.78228 8.75 9.22999C8.75 7.42932 10.1875 5.9375 12 5.9375C13.8125 5.9375 15.25 7.42932 15.25 9.22999C15.25 10.6834 14.3135 11.9356 12.9992 12.3645C12.9991 12.5708 12.999 12.804 12.999 13.0508C12.999 13.6031 12.5513 14.0508 11.999 14.0508C11.4467 14.0508 10.999 13.6031 10.999 13.0508C10.999 12.6284 10.9993 12.246 10.9995 11.9692L11 11.5216C11.0008 10.9698 11.4483 10.5225 12 10.5225C12.6728 10.5225 13.25 9.96154 13.25 9.23C13.25 8.49845 12.6728 7.9375 12 7.9375ZM11.999 15.5C12.5513 15.5 12.999 15.9477 12.999 16.5V16.5396C12.999 17.0918 12.5513 17.5396 11.999 17.5396C11.4467 17.5396 10.999 17.0918 10.999 16.5396V16.5C10.999 15.9477 11.4467 15.5 11.999 15.5Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Support;
